import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { LMCaptchaControlService } from '@field/captchacontrol/lm-captcha-control.service';

@Component({
  selector: 'lm-captcha-control',
  standalone: false,
  templateUrl: 'lm-captcha-control.component.html',
  styleUrls: [ 'lm-captcha-control.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
  })
export class LMCaptchaControlComponent implements OnInit {
  public captchaBase64ImageUrl: string |  undefined;
  public captchaBase64AudioUrl: string | undefined;
  public isValid: boolean | undefined;

  @Input() layoutObject: LMCaptchaControl | undefined;

  @HostBinding('class.align-right') isRightAlign: boolean | undefined;
  @HostBinding('class.align-center') isCenterAlign: boolean | undefined;
  @HostBinding('class.parent-is-paragraph') @Input() parentIsParagraph: boolean | undefined;

  constructor(
    private lmCaptchaControlService: LMCaptchaControlService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.load();
    this.lmCaptchaControlService.captchaChanged.subscribe(() => this.reload());
  }

  public set captchaValue(value: string) {
    this.lmCaptchaControlService.setCaptchaValue(value);
  }

  private load(): void {
    if (this.layoutObject) {
      this.isCenterAlign = this.layoutObject.alignCenter;
      this.isRightAlign = this.layoutObject.alignRight;
    }

    this.lmCaptchaControlService.getCaptchaBase64Urls().then((lmCaptchaResponse: LMCaptchaResponse) => {
      this.captchaBase64ImageUrl = lmCaptchaResponse.base64ImageUrl;

      const base64AudioUrl = lmCaptchaResponse.base64AudioUrl;
      if (base64AudioUrl) {
        this.captchaBase64AudioUrl = lmCaptchaResponse.base64AudioUrl;
      }

      this.changeDetectorRef.detectChanges();
    });
  }

  public reload() {
    this.load();
  }
}
